<template>
  <div class="Circle">
    <canvas ></canvas>
  </div>
</template>

<script>

import gsap from "gsap"
import * as dat from 'dat.gui'
import Line from './Line.js'

export default {

  name: 'Circle',
  data: ()=>({
    c: null,
    ctx: null,
    w: null,
    h: null,
    lines: null,
    tick: null,
    tau: null,
    scale: null,
    base: null,
    gui: null,
    config: null,
  }),

  mounted() {

    /*=============================================
    Configuration
    =============================================*/

    this.base = [
      {
        name: 'radius',
        default: 150,
        min: 3,
        max: 300,
        step: 1,
        randomize: 1
      },
      {
        name: 'lineCount',
        default: 100,
        min: 3,
        max: 2000,
        step: 1,
        randomize: 1
      },
      {
        name: 'lineWidth',
        default: 3,
        min: 1,
        max: 3,
        step: 1,
        randomize: 1
      },
      {
        name: 'length',
        default: 10,
        min: 1,
        max: 100,
        step: 1,
        randomize: 1
      },
      {
        name: 'lengthMove',
        default: 10,
        min: 0,
        max: 100,
        step: 1,
        randomize: 1
      },
      {
        name: 'offset',
        default: 1,
        min: 0,
        max: 100,
        step: 1,
        randomize: 1
      },
      {
        name: 'speed',
        default: 0.005,
        min: 0.001,
        max: 0.015,
        step: 0.001,
        randomize: 1
      },
      {
        name: 'spin',
        default: 0.005,
        min: -0.02,
        max: 0.02,
        step: 0.001,
        randomize: 1
      },
      {
        name: 'pulse',
        default: 0.1,
        min: 0,
        max: 0.2,
        step: 0.001,
        randomize: 1
      },
      {
        name: 'hueBase',
        default: 30,
        min: 0,
        max: 360,
        step: 1,
        randomize: 1
      },
      {
        name: 'hueRange',
        default: 30,
        min: 0,
        max: 90,
        step: 1,
        randomize: 1
      }
    ]

    this.gui = new dat.GUI()
    this.config = {}

    this.base.forEach( ( opt )=> {
      this.config[ opt.name ] = opt.default
      let controller = this.gui.add( this.config, opt.name )
                      .min( opt.min )
                      .max( opt.max )
                      .step( opt.step )
                      .listen()

          controller.onChange( this.reset )
    })

    this.config.randomize = ()=> {
      this.base.forEach( ( opt )=> {
        if( opt.randomize ) {
          this.config[ opt.name ] = Math.ceil( this.rand( opt.min, opt.max ) / opt.step ) * opt.step;
        }
      })
      this.reset()
    }

    this.gui.add( this.config, 'randomize' )

    /*=============================================
    Lines
    =============================================*/

    this.init()

  },

  methods:{

    /*=============================================
    Utility
    =============================================*/

    rand( min, max ) {
      return Math.random() * ( max - min ) + min
    },
    normalizeFromCenter( val, max ) {
      return ( max - Math.abs( max - ( val * 2 ) ) ) / max
    },

    /*=============================================
    Scene
    =============================================*/

    init() {

      console.log('Init Circle');

      this.c = document.querySelector( 'canvas' )    
      this.ctx = this.c.getContext( '2d' )
      this.lines = []
      this.tick = 0
      this.tau = Math.PI * 2
      this.config.randomize()

      // return

      this.reset()
      this.loop()

    },

    reset() {

      console.log('reset');

      this.w = innerWidth
      this.h = innerHeight
      this.lines.length = 0

      for( let i = 0; i < this.config.lineCount; i++ ) {

        const ln = new Line({
          angle: i / this.config.lineCount * this.tau - Math.PI / 2,
          length: this.config.length,
          lengthMove: this.config.lengthMove,
          radius: this.config.radius,
          offset: ( this.normalizeFromCenter( i, this.config.lineCount ) * this.config.offset ) / this.config.speed,
          hue: this.config.hueBase + this.rand( -this.config.hueRange / 2, this.config.hueRange / 2 )
        })

        this.lines.push(ln)
      }

      this.c.width = this.w
      this.c.height = this.h
      this.ctx.lineWidth = this.config.lineWidth
      this.ctx.globalCompositeOperation = 'lighter'
    },

    step() {
      let i = this.lines.length
      while( i-- ) { this.lines[ i ].step(this.config) }
      this.tick++
    },

    draw() {

      this.ctx.clearRect( 0, 0, this.w, this.h )
      this.ctx.save()
      this.ctx.translate( this.w / 2, this.h / 2 )

      // this.scale = 0.9 + Math.sin( this.tick * this.config.pulse ) * 0.1
      this.scale = 1
      this.ctx.scale( this.scale, this.scale )

      this.ctx.fillStyle = 'hsla(' + this.config.hueBase + ', 70%, 50%, 0.1)'

      // this.ctx.beginPath()
      // this.ctx.arc( 0, 0, this.config.radius / 3, 0, this.tau )
      // this.ctx.fill()
      // this.ctx.beginPath();
      // this.ctx.arc( 0, 0, this.config.radius / 3 * 2, 0, this.tau )
      // this.ctx.fill()
      // this.ctx.beginPath()
      // this.ctx.arc( 0, 0, this.config.radius - this.config.lineWidth / 2, 0, this.tau )
      // this.ctx.fill()
      // this.ctx.beginPath()
      // this.ctx.arc( 0, 0, this.config.radius, 0, this.tau )
      // this.ctx.strokeStyle = 'hsla(' + this.config.hueBase + ', 70%, 50%, 0.5)'
      // this.ctx.stroke()

      // this.ctx.rotate( this.tick * this.config.spin ) 
      this.ctx.rotate( this.tick * 0 ) 

      let i = this.lines.length
      while( i-- ) { this.lines[ i ].draw(this.ctx) }
      this.ctx.restore()

    },

    loop() {
      requestAnimationFrame( this.loop )
      this.step()
      this.draw()
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Circle
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  

  canvas 
    display block
    height 100vh
    border none

  body .dg .c .slider-fg 
    background #666 

  .slider-fg 
    transition width 150ms 

  .slider:active .slider-fg 
    transition-duration 0ms

</style>


